export default "__VITE_ASSET__B9d8qSdO__"